import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import './App.css';
import Result from './Result';
import Search from './Search';
import { getServiceRequest } from './core/api';
import { Alert } from '@mui/material';

function App() {
  const [id, setId] = useState();
  const [error, setError] = useState();
  const [response, setResponse] = useState();
  const [loading, setLoading] = useState(false);

  const handleSubmit = (newId) => {
    setId(newId);
  }

  useEffect(() => {
    if (id) {
      setLoading(true);
      setResponse(null);
      setError(null);
      getServiceRequest(id)
        .then((r) => {
          setResponse(r);
          setLoading(false);
          setError(null);
        })
        .catch(() => {
          setResponse(null);
          setError('No se pudo obtener la información');
          setLoading(false);
        })
    }
  }, [id])

  return (
    <div className="App">
      <header className="App-header">
        <AppBar position="static" color="transparent">
          <Toolbar>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Track Tiempos de Espera
            </Typography>
          </Toolbar>
        </AppBar>
      </header>
      <div className='page'>
        <Search onSubmit={handleSubmit} loading={loading}/>
        {error && (
          <Alert severity='warning'>
            {error}
          </Alert>
        )}
        {response && (
          <Result response={response} />
        )}
      </div>
    </div>
  );
}

export default App;
